var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-date-picker',{attrs:{"type":"year","placeholder":"选择年","size":"mini","clearable":false},on:{"change":_vm.handlePickerChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }